export const reportMenuData = translations => [
  {
    country: translations.unitedStates || 'United States',
    teams: [
      {
        name: 'Depot',
        reports: [
          {
            name: 'Bench Repair',
            componentKey: 'BenchRepairReport',
          },
          {
            name: 'RLT Worklog',
            componentKey: 'RltWorklogReport',
          },
        ],
      },
      {
        name: 'FST',
        reports: [
          {
            name: 'Field Service Score Card',
            componentKey: 'FieldServiceScoreCard',
          },
          {
            name: translations.incorrectCase || 'Incorrect Case',
            componentKey: 'IncorrectCaseReport',
          },
          {
            name: translations.overtime || 'Overtime',
            componentKey: 'FSTOvertimeReport',
          },
        ],
      },
      {
        name: 'ITS',
        reports: [
          {
            name: 'Texas Scratch Ticket Order Report',
            componentKey: 'ITSTexasScratchTicketReport',
          },
        ],
      },
      {
        name: 'NRC',
        reports: [
          {
            name: 'Antilles Credit Log',
            componentKey: 'AntillesCreditLogReport',
          },
          {
            name: 'California PTL',
            componentKey: 'CaliforniaPTLReport',
          },
          {
            name: 'Consumable Supply',
            componentKey: 'ConsumableSupplyReport',
          },
          {
            name: 'Dispatch Status Change Request',
            componentKey: 'DispatchStatusChangeRequestReport',
          },
          {
            name: 'Forward-To-Site',
            componentKey: 'ForwardToSiteReport',
          },
          {
            name: 'GNIE Update Request',
            componentKey: 'GNIEUpdateRequestReport',
          },
          {
            name: 'Michigan Incident Log',
            componentKey: 'MichiganIncidentLogReport',
          },
          {
            name: 'New Jersey Function Suppressed',
            componentKey: 'NJSuppressedReport',
          },
          {
            name: 'New York AM Log',
            componentKey: 'NYAMLogReport',
          },
          {
            name: 'New York Key Request',
            componentKey: 'NYKeyRequestReport',
          },
          {
            name: 'NRC Downtime',
            componentKey: 'NRCDowntimeReport',
          },
          {
            name: 'Retailer Information Change',
            componentKey: 'RetailerInfoChangeReport',
          },
          {
            name: 'Stolen & Missing Instant Ticket Report',
            componentKey: 'StolenAndMissingInstantTicketReport',
          },
          {
            name: 'Texas Scratch Ticket Order Report',
            componentKey: 'TexasScratchTicketReport',
          },
          {
            name: 'Washington Retailer Training Request',
            componentKey: 'WARetailerTrainingRequestReport',
          },
        ],
      },
    ],
  },
  {
    country: 'Chile',
    teams: [
      {
        name: translations.contactCenter,
        reports: [
          {
            name:
              translations.genesysCloudInteractionSurvey ||
              'Genesys Cloud Interaction Survey',
            componentKey: 'CLGenesysCloudSurvey',
          },
        ],
      },
    ],
  },
  {
    country: translations.czechRepublic || 'Czech Republic',
    teams: [
      {
        name: translations.contactCenter,
        reports: [
          {
            name:
              translations.genesysCloudInteractionSurvey ||
              'Genesys Cloud Interaction Survey',
            componentKey: 'CZGenesysCloudSurvey',
          },
        ],
      },
    ],
  },
];
